// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-stack__item.m-stack__item--middle.m-brand__tools[data-v-5da6339f] {\n  width: 2rem;\n}\n.m-brand[data-v-5da6339f] {\n  height: 60px;\n  z-index: 0;\n  padding-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
